/* eslint-disable camelcase */
import React from 'react';
import SellItPerformance from './sell-it-performance';
import { destandard } from '../../../utils/commonFunctions';

const SellItPerformances = (props) => {
  const { performances, current_user } = props;

  return (
    <div>
      {
        performances.map((value, key) => {
          const performance = destandard({...value});
          return (
            performance.incentives && performance.incentives.length && (
            <SellItPerformance
              {...performance}
              key={key}
              index={key}
              outlet={value.id}
              current_user={current_user}
            />
          )
        ) || false;
        })
      }
    </div>
  );
};

export default SellItPerformances;




// WEBPACK FOOTER //
// ./src/components/store-performance/sell-it/sell-it-performances.jsx